import { useEffect, useState, useRef } from 'react';

type HighlightHook = <T>(newItems: T[], duration?: number) => T[];

export const useHighlightOnNewItems: HighlightHook = (newItems, duration = 3000) => {
  const [highlightedItems, setHighlightedItems] = useState<(typeof newItems)[0][]>([]);
  const timeoutsRef = useRef<NodeJS.Timeout[]>([]);

  useEffect(() => {
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];

    newItems.forEach((item) => {
      if (!highlightedItems.includes(item)) {
        setHighlightedItems((prev) => [...prev, item]);

        const timeout = setTimeout(() => {
          setHighlightedItems((prev) => prev.filter((i) => i !== item));
        }, duration);

        timeoutsRef.current.push(timeout);
      }
    });

    return () => {
      timeoutsRef.current.forEach(clearTimeout);
      timeoutsRef.current = [];
    };
  }, [newItems, duration]);

  return highlightedItems;
};
